import React, { Component, useContext, useState, useEffect } from "react";
import Colorer from 'color';
import styled, { css } from "styled-components";
import { ProductContext } from '../context'

export default function Bg({
  absolute,
  plain,
  theme,
  effect,
  z0,
  z1,
  style
}) {

  const valueFromContext = useContext(ProductContext);

  theme= theme || valueFromContext['theme']

  if (valueFromContext) {return (
    <CSSbg0
      absolute={absolute}
      style={style}
      z0={z0}
      z1={z1}
    >
      {theme['backgroundUrl'] && <CssGlobalBg
        effect={effect}
        absolute={absolute}
        backgroundUrl={!plain && ((theme && theme['backgroundUrl']) ? theme['backgroundUrl'] : valueFromContext.theme['backgroundUrl'])}
        backgroundColor={plain ? Colorer(theme['colorBg']).darken(0).string() : null}
      />}
      <CssGlobalTint
        absolute={absolute}
        theme={theme || valueFromContext.getTheme()}
      />
    </CSSbg0>
  )} else {
    return null;
  }
}




const CSSbg0 = styled.div`
  ${({z0})=> !!z0 && css`
    z-index: -1
  `}
  ${({z1})=> !!z1 && css`
    z-index: 1
  `}
  ${({backgroundUrl})=> !!backgroundUrl && css`
    position: ${({absolute}) => absolute ? 'absolute' : 'fixed'};
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  `}
`

const CssGlobalBg = styled.div`
  ${({backgroundUrl})=> !!backgroundUrl && css`
    /* background-image: url(${({backgroundUrl})=>backgroundUrl}); */
    background-color: black;
  `};


  position: ${({absolute}) => absolute ? 'absolute' : 'fixed'};
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;

  &:after {
    content: '';
    position: ${({absolute}) => absolute ? 'absolute' : 'fixed'};
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-size: cover;
    background-position: 50% 50%;
    background-image: url(${({backgroundUrl})=>backgroundUrl});
    ${({effect})=> effect && css`
      left: -34px;
      right: -34px;
      top: -34px;
      bottom: -34px;
      filter: blur(20px);
    `}
  };
  /* ${({backgroundColor})=> !!backgroundColor && css`
    background-color: ${backgroundColor};
  `}; */


`
const CssGlobalTint = styled.div`
  position: ${({absolute}) => absolute ? 'absolute' : 'fixed'};
  /* background-color: ${props=>props.colorBg}; */
  background-color: ${({theme}) => {
    let colorBg = Colorer(theme.colorBg).luminosity() < 0.0065 ?
    Colorer(theme.colorBg)
    .lighten(0.5)
    .alpha(0.8)
    .string()
    :
    Colorer(theme.colorBg)
    .darken(0.9)
    .alpha(0.8)
    .string();
    return colorBg;
  }};
/* opacity: 0.8; */
  /* z-index: 0; */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`

